export class SiteLinks {
  supportLink: string;
  webmailLink: string;
  legalLink: string;
  acceptableUsePolicyLink: string;
  nbnKeyFactsSheet: string;
  invoiceHelpLink: string;
  payInvoiceLink: string;
  aboutMeLink: string;
  paymentDetailsLink: string;
  notificationsLink: string;
  linkAccountsLink: string;
  newsletterSamplesLink: string;
  privacyPolicyLink: string;
  confirmDataPackHelpLink: string;
  changePlanHelpLink: string;
  criticalInformationSummaryLink: string;
  fetchInfoLink: string;
  fetchMultiroomInfoLink: string;
  craLink: string;
  callRatesLink: string;
  callRatesLinkWireless: string;
  roamingHelpLink: string;
  mobileCallRates: string;
  mobileTermsSummary: string;
  mobileCis: Map<string, string>;
  highSpeedNbnRequirementsLink: string;
  forgotUsernameLink: string;
  forgotPasswordLink: string;
  speedTestLink: string;
  homeWirelessDrupalLink: string;
  stagingHomeWirelessDrupalLink: string;
  homeWirelessLiimitlessCis: string;
  homeWirelessHundredCis: string;
  homeWireless5GCis: string;
  homeWirelessChangePlanHelpLink: string;
  craSummaryLink: string;
  legalCraLink: string;
  byoModemLink: string;
  legacyToolboxLink: string;
  dataRetentionPolicyLink: string;
  fibreConnectUpgradeMoreInfo: string;
  compatibleHardwareLink: string;
  fibreConnectUpgradeTermsLink: string;
  emailMessagingCompanyLink: string;
  internationalRoamingLink: string;
  nbnPriceChangeLink: string;
  financialHardshipLink: string;
  fetchCeaseSaleLink: string;
  intlValueCallPackLink: string;
  networkOutageLink: string;
}
